import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import heroImg from '../Images/get-a-quote-breadcrumb.webp'
import Header from "../Components/Header";
import BreadcrumbMain from "../Components/BreadcrumbMain";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaLock,
} from "react-icons/fa";
import { services } from "../Data";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useRecaptcha } from "../Components/ReCaptcha";
import SchemaMarkup from "../Components/SchemaMarkup";
import breadcrumbSchema from '../Schemas/breadcrumbSchema'

const GetAQuote=()=>{
     useEffect(() => {
            document.title =
              "Request a Settlement Quote | LDL Settlement Services";
        
            const metaDesc = document.querySelector("meta[name='description']");
            if (metaDesc) {
              metaDesc.setAttribute(
                "content",
                "Request a free quote for residential or commercial property settlement services in Perth & Western Australia."
              );
            }
        
            const canonical = document.querySelector("link[rel='canonical']");
          if (canonical) {
            canonical.setAttribute("href", "https://ldlsettlementservices.com.au/get-a-quote");
          }
        
          const ogTitle = document.querySelector("meta[property='og:title']");
          if (ogTitle) {
            ogTitle.setAttribute(
              "content",
              "Request a Settlement Quote | LDL Settlement Services"
            );
          }
        
            const ogDesc = document.querySelector("meta[property='og:description']");
          if (ogDesc) {
            ogDesc.setAttribute(
              "content",
              "Request a free quote for residential or commercial property settlement services in Perth & Western Australia."
            );
          }
        
          const ogUrl = document.querySelector("meta[property='og:url']");
          if (ogUrl) {
            ogUrl.setAttribute("content", "https://ldlsettlementservices.com.au/get-a-quote");
          }
        
            const ogImage = document.querySelector("meta[property='og:image']");
          if (ogImage) {
            ogImage.setAttribute(
              "content",
              "https://ldlsettlementservices.com.au/Images/quote-img.webp"
            );
          }
        
            const twitterTitle = document.querySelector("meta[name='twitter:title']");
          if (twitterTitle) {
            twitterTitle.setAttribute(
              "content",
              "Request a Settlement Quote | LDL Settlement Services"
            );
          }
        
            const twitterDesc = document.querySelector(
            "meta[name='twitter:description']"
          );
          if (twitterDesc) {
            twitterDesc.setAttribute(
              "content",
              "Request a free quote for residential or commercial property settlement services in Perth & Western Australia."
            );
          }
        
            const twitterImage = document.querySelector("meta[name='twitter:image']");
          if (twitterImage) {
            twitterImage.setAttribute(
              "content",
              "https://ldlsettlementservices.com.au/Images/quote-img.webp"
            );
          }
          }, []);
 const [formData, setFormData] = useState({
  firstName: "",
  lastName: "",
  email: "",
  phoneNumber: "",
  address: "",
  buyerSeller: "",
  requestingService: "",
  service: "",
  message: "",
  contractFile: null,
});

const [loading, setLoading] = useState(false);
const generateToken = useRecaptcha();

const handleChange = (e) => {
  const { name, value, files, type } = e.target;

  if (type === "file") {

    setFormData((prev) => ({
      ...prev,
      [name]: files[0],
    }));

    return;
  }

  setFormData((prev) => ({
    ...prev,
    [name]: value,
  }));
};

const handleSubmit = async (e) => {
  e.preventDefault();

  if (!formData.firstName)
    return toast.error("Please enter first name");

  if (!formData.lastName)
    return toast.error("Please enter last name");

  if (!formData.email)
    return toast.error("Please enter email");

  if (!formData.phoneNumber)
    return toast.error("Please enter phone number");

  if (!formData.address)
    return toast.error("Please enter address");

  if (!formData.buyerSeller)
    return toast.error("Please select buyer or seller");

  if (!formData.requestingService)
    return toast.error("Please select service requirement");

  if (!formData.service)
    return toast.error("Please select a service");

  if (!formData.message)
    return toast.error("Please enter message");

  const phoneRegex = /^[0-9]{8,15}$/;

  if (!phoneRegex.test(formData.phoneNumber)) {
    return toast.error(
      "Please enter a valid 10 digit phone number"
    );
  }

  setLoading(true);
generateToken(async (token) => {

  try {

    // VERIFY RECAPTCHA

    const recaptchaData = new FormData();

    recaptchaData.append(
      "secret",
      "6LdQeRwtAAAAAJF7CHdPYH3dCyF2g2-mdQc_SSAn"
    );

    recaptchaData.append(
      "response",
      token
    );

    const verifyRes = await axios.post(
      "https://api.sendmail.adhyaynam.in/recaptcha-verify",
      recaptchaData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    const score =
      verifyRes.data.score ||
      verifyRes.data.data?.score;


    // BLOCK SPAM

    if (!score || score <= 0.5) {

      toast.error(
        "Spam detected. Please try again."
      );

      setLoading(false);

      return;
    }

    // -------------------------
    // KEEP YOUR TEMPLATE HERE
    // -------------------------

     const template = `
<div style="margin:0;padding:40px 0;background:#F5F7FA;font-family:Poppins,Arial,sans-serif;">

  <table width="100%" cellpadding="0" cellspacing="0" border="0">
    <tr>
      <td align="center">

        <table
          width="700"
          cellpadding="0"
          cellspacing="0"
          border="0"
          style="
            background:#ffffff;
            border-radius:20px;
            overflow:hidden;
            box-shadow:0 12px 40px rgba(0,0,0,0.08);
          "
        >

          <!-- TOP BAR -->

          <tr>
            <td
              style="
                height:8px;
                background:linear-gradient(
                  90deg,
                  #18263C,
                  #A88B53
                );
              "
            ></td>
          </tr>

          <!-- HEADER -->

          <tr>
            <td
              style="
                background:#18263C;
                padding:40px;
                text-align:center;
              "
            >

             <img
            src="https://ldlsettlementservices.com.au/logo.png"
            alt="LDL Settlement Services Logo"
            style="
              max-width:220px;
              display:block;
              margin:0 auto 24px;
            "
          />

              <h1
                style="
                  margin:0;
                  color:#ffffff;
                  font-size:30px;
                  font-weight:700;
                "
              >
                New Quote Request
              </h1>

              <p
                style="
                  margin:15px 0 0;
                  color:#D6DCE7;
                  font-size:15px;
                  line-height:1.8;
                "
              >
                A new settlement quote request has been submitted
                through the LDL Settlement Services website.
              </p>

            </td>
          </tr>

          <!-- CONTENT -->

          <tr>
            <td style="padding:40px;">

              <!-- CLIENT DETAILS -->

              <h2
                style="
                  margin:0 0 20px;
                  color:#18263C;
                  font-size:22px;
                "
              >
                Client Information
              </h2>

              <table
                width="100%"
                cellpadding="0"
                cellspacing="0"
                style="
                  border:1px solid #E6EAF0;
                  border-radius:16px;
                  overflow:hidden;
                "
              >

                <tr>
                  <td style="padding:18px 22px;border-bottom:1px solid #E6EAF0;">
                    <span style="color:#7A8699;">First Name</span><br/>
                    <strong style="color:#18263C;">
                      ${formData.firstName}
                    </strong>
                  </td>
                </tr>

                <tr>
                  <td style="padding:18px 22px;border-bottom:1px solid #E6EAF0;">
                    <span style="color:#7A8699;">Last Name</span><br/>
                    <strong style="color:#18263C;">
                      ${formData.lastName}
                    </strong>
                  </td>
                </tr>

                <tr>
                  <td style="padding:18px 22px;border-bottom:1px solid #E6EAF0;">
                    <span style="color:#7A8699;">Email Address</span><br/>
                    <strong style="color:#18263C;">
                      ${formData.email}
                    </strong>
                  </td>
                </tr>

                <tr>
                  <td style="padding:18px 22px;border-bottom:1px solid #E6EAF0;">
                    <span style="color:#7A8699;">Phone Number</span><br/>
                    <strong style="color:#18263C;">
                      ${formData.phoneNumber}
                    </strong>
                  </td>
                </tr>

                <tr>
                  <td style="padding:18px 22px;">
                    <span style="color:#7A8699;">Address</span><br/>
                    <strong style="color:#18263C;">
                      ${formData.address}
                    </strong>
                  </td>
                </tr>

              </table>

              <!-- TRANSACTION DETAILS -->

              <h2
                style="
                  margin:35px 0 20px;
                  color:#18263C;
                  font-size:22px;
                "
              >
                Settlement Details
              </h2>

              <table
                width="100%"
                cellpadding="0"
                cellspacing="0"
                style="
                  border:1px solid #E6EAF0;
                  border-radius:16px;
                  overflow:hidden;
                "
              >

                <tr>
                  <td style="padding:18px 22px;border-bottom:1px solid #E6EAF0;">
                    <span style="color:#7A8699;">Client Type</span><br/>
                    <strong style="color:#18263C;">
                      ${formData.buyerSeller}
                    </strong>
                  </td>
                </tr>

                <tr>
                  <td style="padding:18px 22px;border-bottom:1px solid #E6EAF0;">
                    <span style="color:#7A8699;">Requesting Additional Services</span><br/>
                    <strong style="color:#18263C;">
                      ${formData.requestingService}
                    </strong>
                  </td>
                </tr>

                <tr>
                  <td style="padding:18px 22px;">
                    <span style="color:#7A8699;">Selected Service</span><br/>
                    <strong style="color:#A88B53;font-size:16px;">
                      ${formData.service}
                    </strong>
                  </td>
                </tr>

              </table>

              <!-- ATTACHMENT -->

              <div
                style="
                  margin-top:30px;
                  background:#FFF8EA;
                  border-left:4px solid #A88B53;
                  padding:18px 22px;
                  border-radius:10px;
                "
              >

                <strong
                  style="
                    color:#18263C;
                    display:block;
                    margin-bottom:6px;
                  "
                >
                  Contract Attachment
                </strong>

                <span style="color:#555;">
                  ${
                    formData.contractFile
                      ? formData.contractFile.name
                      : "No file attached"
                  }
                </span>

              </div>

              <!-- MESSAGE -->

              <div style="margin-top:35px;">

                <h2
                  style="
                    margin:0 0 15px;
                    color:#18263C;
                    font-size:22px;
                  "
                >
                  Additional Notes
                </h2>

                <div
                  style="
                    background:#F8FAFC;
                    border:1px solid #E6EAF0;
                    border-radius:14px;
                    padding:24px;
                    color:#0F1826;
                    line-height:1.9;
                  "
                >
                  ${formData.message}
                </div>

              </div>

            </td>
          </tr>

          <!-- FOOTER -->

          <tr>
            <td
              style="
                background:#18263C;
                text-align:center;
                padding:30px;
              "
            >

              <p
                style="
                  margin:0;
                  color:#D6DCE7;
                  font-size:13px;
                  line-height:1.8;
                "
              >
                LDL Settlement Services<br/>
                Perth, Western Australia
              </p>

            </td>
          </tr>

        </table>

      </td>
    </tr>
  </table>

</div>
`;


    const data = new FormData();

    data.append(
      "title",
      "LDL Website Quote Form"
    );

    data.append(
      "to_email",
      "admin@ldlsettlementservices.com.au"
    );

    data.append(
      "cc",
      "arkayappsseo@gmail.com,sales@arkayapps.com"
    );

    data.append(
      "subject",
      "LDL : New Quote Request"
    );

    data.append(
      "template",
      template
    );

    if (formData.contractFile) {
      data.append(
        "file",
        formData.contractFile
      );
    }

    await axios.post(
      "https://api.sendmail.adhyaynam.in/send-mail/two",
      data,
      {
        headers: {
          "Content-Type":
            "multipart/form-data",
        },
      }
    );

    toast.success(
      "Quote request submitted successfully 🚀"
    );

    setFormData({
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      address: "",
      buyerSeller: "",
      requestingService: "",
      service: "",
      message: "",
      contractFile: null,
    });

  } catch (error) {

    toast.error(
      "Verification failed. Please try again!"
    );

  } finally {

    setLoading(false);

  }

});
}

const breadcrumbs = breadcrumbSchema([
  {
    name: "Home",
    url: "https://ldlsettlementservices.com.au/"
  },
  {
    name: "Get a Quote"
  }
]);
    return(
        <>

<SchemaMarkup schema={breadcrumbs} />

        <Header
        showBreadcrumb={true}
        pageName="Get a Quote"
      />

      {/**HERO SECTION */}
       <BreadcrumbMain
      subTitle="GET A QUOTE"
      title="Request a Quote
It’s Quick & Easy"
      description="Provide a few details about your property transaction and we will get back to you with a competitive quote."
      image={heroImg}
      showIcons={false}
    />

    {/**FORM SECTION */}

<section className="contact-form-section quote-form-section container">

  {/* LEFT FORM */}

  <motion.div
    className="contact-form-wrapper"
    initial={{
      opacity: 0,
      x: -70,
    }}
    whileInView={{
      opacity: 1,
      x: 0,
    }}
    transition={{
      duration: 1,
      ease: [0.22, 1, 0.36, 1],
    }}
    viewport={{
      once: true,
      amount: 0.15,
    }}
  >

    <motion.h2
      className="section-heading"
      initial={{
        opacity: 0,
        y: 35,
      }}
      whileInView={{
        opacity: 1,
        y: 0,
      }}
      transition={{
        duration: 0.85,
        ease: [0.22, 1, 0.36, 1],
      }}
      viewport={{
        once: true,
      }}
    >
      Send us a Message
    </motion.h2>

    <motion.p
      className="section-text contact-top-text"
      initial={{
        opacity: 0,
        y: 35,
      }}
      whileInView={{
        opacity: 1,
        y: 0,
      }}
      transition={{
        duration: 0.95,
        delay: 0.08,
        ease: [0.22, 1, 0.36, 1],
      }}
      viewport={{
        once: true,
      }}
    >
      Fill out the form below and we’ll get back to you as soon as possible
    </motion.p>

    <motion.form
  className="contact-form"
  onSubmit={handleSubmit}
      initial="hidden"
      whileInView="visible"
      viewport={{
        once: true,
        amount: 0.12,
      }}
      variants={{
        hidden: {},
        visible: {
          transition: {
            staggerChildren: 0.08,
          },
        },
      }}
    >

      {/* ROW 1 */}

      <div className="form-row">

        <motion.div
          className="form-group"
          variants={{
            hidden: {
              opacity: 0,
              y: 35,
            },
            visible: {
              opacity: 1,
              y: 0,
              transition: {
                duration: 0.75,
                ease: [0.22, 1, 0.36, 1],
              },
            },
          }}
        >

          <label>
            First Name *
          </label>

          <motion.input
            ttype="text"
  name="firstName"
  value={formData.firstName}
  onChange={handleChange}
  placeholder="Enter First Name"
            whileFocus={{
              scale: 1.01,
            }}
          />

        </motion.div>

        <motion.div
          className="form-group"
          variants={{
            hidden: {
              opacity: 0,
              y: 35,
            },
            visible: {
              opacity: 1,
              y: 0,
              transition: {
                duration: 0.75,
                ease: [0.22, 1, 0.36, 1],
              },
            },
          }}
        >

          <label>
            Last Name *
          </label>

          <motion.input
           type="text"
  name="lastName"
  value={formData.lastName}
  onChange={handleChange}
  placeholder="Enter Last Name"
            whileFocus={{
              scale: 1.01,
            }}
          />

        </motion.div>

      </div>

      {/* ROW 2 */}

      <div className="form-row">

        <motion.div
          className="form-group"
          variants={{
            hidden: {
              opacity: 0,
              y: 35,
            },
            visible: {
              opacity: 1,
              y: 0,
              transition: {
                duration: 0.75,
                ease: [0.22, 1, 0.36, 1],
              },
            },
          }}
        >

          <label>
            Email *
          </label>

          <motion.input
           type="email"
  name="email"
  value={formData.email}
  onChange={handleChange}
  placeholder="Enter your Email"
            whileFocus={{
              scale: 1.01,
            }}
          />

        </motion.div>

        <motion.div
          className="form-group"
          variants={{
            hidden: {
              opacity: 0,
              y: 35,
            },
            visible: {
              opacity: 1,
              y: 0,
              transition: {
                duration: 0.75,
                ease: [0.22, 1, 0.36, 1],
              },
            },
          }}
        >

          <label>
            Phone Number *
          </label>

          <motion.input
             type="text"
  name="phoneNumber"
  value={formData.phoneNumber}
  onChange={handleChange}
  placeholder="Enter Contact Number"
            whileFocus={{
              scale: 1.01,
            }}
          />

        </motion.div>

      </div>

      {/* ADDRESS */}

      <motion.div
        className="form-group full-width-group"
        variants={{
          hidden: {
            opacity: 0,
            y: 35,
          },
          visible: {
            opacity: 1,
            y: 0,
            transition: {
              duration: 0.75,
              ease: [0.22, 1, 0.36, 1],
            },
          },
        }}
      >

        <label>
          Address *
        </label>

        <motion.input
            type="text"
  name="address"
  value={formData.address}
  onChange={handleChange}
  placeholder="Enter your Address"
          whileFocus={{
            scale: 1.01,
          }}
        />

      </motion.div>

      {/* CHOOSE ONE */}

      <motion.div
        className="checkbox-group"
        variants={{
          hidden: {
            opacity: 0,
            y: 35,
          },
          visible: {
            opacity: 1,
            y: 0,
            transition: {
              duration: 0.75,
              ease: [0.22, 1, 0.36, 1],
            },
          },
        }}
      >

        <label className="checkbox-title">
          Please Choose One *
        </label>

        <div className="checkbox-options">

         {[
  "I'm a Buyer",
  "I'm a Seller",
  "Other"
].map((item, i) => (
  <label key={i} className="custom-checkbox">

    <input
      type="radio"
      name="buyerSeller"
      value={item}
      checked={formData.buyerSeller === item}
      onChange={handleChange}
    />

    <span className="checkmark"></span>

    <span className="checkbox-label">
      {item}
    </span>

  </label>
))}

        </div>

      </motion.div>

      {/* SERVICES */}

      <motion.div
        className="checkbox-group"
        variants={{
          hidden: {
            opacity: 0,
            y: 35,
          },
          visible: {
            opacity: 1,
            y: 0,
            transition: {
              duration: 0.75,
              ease: [0.22, 1, 0.36, 1],
            },
          },
        }}
      >

        <label className="checkbox-title">
          Are You Requesting any Services ? *
        </label>

        <div className="checkbox-options">

         {["Yes", "No"].map((item, i) => (
  <label key={i} className="custom-checkbox">

    <input
      type="radio"
      name="requestingService"
      value={item}
      checked={formData.requestingService === item}
      onChange={handleChange}
    />

    <span className="checkmark"></span>

    <span className="checkbox-label">
      {item}
    </span>

  </label>
))}
        </div>

      </motion.div>

      {/* SERVICE + FILE */}

      <div className="form-row">

        <motion.div
          className="form-group"
          variants={{
            hidden: {
              opacity: 0,
              y: 35,
            },
            visible: {
              opacity: 1,
              y: 0,
              transition: {
                duration: 0.75,
                ease: [0.22, 1, 0.36, 1],
              },
            },
          }}
        >

          <label>
            Service *
          </label>

          <motion.select
           name="service"
  value={formData.service}
  onChange={handleChange}
            whileFocus={{
              scale: 1.01,
            }}
          >

           <option value="">
    Select the Service you are looking for
  </option>

            {services.map((item, i) => (
    <option
      key={i}
      value={item.title}
    >
      {item.title}
    </option>
  ))}

          </motion.select>

        </motion.div>

        <motion.div
          className="form-group"
          variants={{
            hidden: {
              opacity: 0,
              y: 35,
            },
            visible: {
              opacity: 1,
              y: 0,
              transition: {
                duration: 0.75,
                ease: [0.22, 1, 0.36, 1],
              },
            },
          }}
        >

          <label>
            Upload Your Contract 
          </label>

         <motion.input
  type="file"
  name="contractFile"
  accept=".pdf,.doc,.docx"
  onChange={handleChange}
  className="file-input"
/>

        </motion.div>

      </div>

      {/* MESSAGE */}

      <motion.div
        className="form-group"
        variants={{
          hidden: {
            opacity: 0,
            y: 35,
          },
          visible: {
            opacity: 1,
            y: 0,
            transition: {
              duration: 0.75,
              ease: [0.22, 1, 0.36, 1],
            },
          },
        }}
      >

        <label>
          Message *
        </label>

        <motion.textarea
         name="message"
  value={formData.message}
  onChange={handleChange}
  placeholder="Enter your Message"
          whileFocus={{
            scale: 1.01,
          }}
        />

      </motion.div>

      {/* BTN */}

    <motion.button
  type="submit"
  disabled={loading}
  className="primary-btn contact-submit-btn"
>
  {loading ? "Sending..." : "Get a Quote"}
</motion.button>

    </motion.form>

  </motion.div>

  {/* RIGHT SIDE */}

  <motion.div
    className="quote-right-wrapper"
    initial={{
      opacity: 0,
      x: 70,
    }}
    whileInView={{
      opacity: 1,
      x: 0,
    }}
    transition={{
      duration: 1,
      ease: [0.22, 1, 0.36, 1],
    }}
    viewport={{
      once: true,
      amount: 0.15,
    }}
  >

    {/* MAP */}

    <motion.div
      className="quote-map-wrap"
      initial={{
        opacity: 0,
        scale: 0.97,
      }}
      whileInView={{
        opacity: 1,
        scale: 1,
      }}
      transition={{
        duration: 1,
        ease: [0.22, 1, 0.36, 1],
      }}
      viewport={{
        once: true,
      }}
    >

      <iframe
        title="LDL Map"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3385.879973991336!2d115.84022937599633!3d-31.937015874025956!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2a32a54843f6ce19%3A0x577f49e939cd8497!2sLDL%20Settlement%20Services!5e0!3m2!1sen!2sin!4v1779874237843!5m2!1sen!2sin"
        allowFullScreen=""
        loading="lazy"
      ></iframe>

    </motion.div>

    {/* INFO */}

    <div className="contact-info-wrapper quote-contact-info">

      <motion.h2
        className="section-heading"
        initial={{
          opacity: 0,
          y: 35,
        }}
        whileInView={{
          opacity: 1,
          y: 0,
        }}
        transition={{
          duration: 0.85,
          ease: [0.22, 1, 0.36, 1],
        }}
        viewport={{
          once: true,
        }}
      >
        Contact Information
      </motion.h2>

      <motion.p
        className="section-text contact-top-text"
        initial={{
          opacity: 0,
          y: 35,
        }}
        whileInView={{
          opacity: 1,
          y: 0,
        }}
        transition={{
          duration: 0.95,
          delay: 0.08,
          ease: [0.22, 1, 0.36, 1],
        }}
        viewport={{
          once: true,
        }}
      >
        Reach out to us for any Inquiries,
        Quotations, or Support.
        <br />
        We will get back to you as soon as possible.
      </motion.p>

      <motion.div
        className="contact-line"
        initial={{
          width: 0,
          opacity: 0,
        }}
        whileInView={{
          width: "100%",
          opacity: 1,
        }}
        transition={{
          duration: 1,
          ease: [0.22, 1, 0.36, 1],
        }}
        viewport={{
          once: true,
        }}
      />

      {[
        {
          icon: <FaPhoneAlt />,
          title: "Phone",
          content: (
            <>
      <a
        href="tel:0861566225"
        className="section-text contact-phone"
      >
        (08) 6156 6225
      </a>

      <a
        href="tel:0420360030"
        className="section-text contact-phone"
      >
        04 2036 0030
      </a>
    </>
          ),
        },
        {
          icon: <FaEnvelope />,
          title: "Email",
          content: (
            <a
              href="mailto:admin@ldlsettlementservices.com.au"
              className="section-text"
            >
              admin@ldlsettlementservices.com.au
            </a>
          ),
        },
        {
          icon: <FaMapMarkerAlt />,
          title: "Address",
          content: (
            <p className="section-text">
              220 Carr Place
              <br />
              Leederville WA 6007
            </p>
          ),
        },
        {
          icon: <FaMapMarkerAlt />,
          title: "Mailing Address",
          content: (
            <p className="section-text">
              PO Box 99
              <br />
              Leederville WA 6902
            </p>
          ),
        },
      ].map((item, i) => (

        <motion.div
          className="contact-info-item"
          key={i}
          initial={{
            opacity: 0,
            y: 35,
          }}
          whileInView={{
            opacity: 1,
            y: 0,
          }}
          transition={{
            duration: 0.8,
            delay: i * 0.12,
            ease: [0.22, 1, 0.36, 1],
          }}
          viewport={{
            once: true,
          }}
          whileHover={{
            x: 6,
          }}
        >

          <motion.div
            className="contact-icon-box"
            whileHover={{
              rotate: -6,
              scale: 1.08,
            }}
            transition={{
              duration: 0.35,
            }}
          >
            {item.icon}
          </motion.div>

          <div className="contact-info-content">

            <h3 className="card-heading">
              {item.title}
            </h3>

            {item.content}

          </div>

        </motion.div>

      ))}

      {/* SECURITY BOX */}

      <motion.div
        className="security-box"
        initial={{
          opacity: 0,
          y: 40,
        }}
        whileInView={{
          opacity: 1,
          y: 0,
        }}
        transition={{
          duration: 0.9,
          delay: 0.35,
          ease: [0.22, 1, 0.36, 1],
        }}
        viewport={{
          once: true,
        }}
        whileHover={{
          y: -5,
        }}
      >

        <motion.div
          className="security-icon"
          whileHover={{
            rotate: -8,
            scale: 1.08,
          }}
          transition={{
            duration: 0.35,
          }}
        >

          <FaLock />

        </motion.div>

        <div className="security-content">

          <h3 className="card-heading">
            Your information is secure
          </h3>

          <p className="section-text">
            We respect your privacy. Your details
            will only be used to respond to your
            quote request.
          </p>

        </div>

      </motion.div>

    </div>

  </motion.div>
<ToastContainer
  position="top-right"
  autoClose={3000}
  hideProgressBar={false}
  newestOnTop={true}
  closeOnClick
  pauseOnHover
  theme="light"
/>
</section>
        </>
    )
}
export default GetAQuote;